import Styles from './styles.module.css';
import Speaker from './../../../image/home/icons/speaker.png';
import AdminShot from './../../../image/landing/fv/admin-recruit-edit.png';
import AppTop from './../../../image/landing/fv/app-top.png';
import AppSalon from './../../../image/landing/fv/app-salon.png';
import { IoDownloadOutline } from "react-icons/io5";

/** プロダクトステージ（PC管理画面＋学生アプリ2枚） */
const Stage = () => (
  <div className={Styles.stage}>
    <div className={Styles.stageGlow} />
    <div className={Styles.stageMain}>
      <img className={Styles.shot} src={AdminShot} alt="サロン管理画面（求人の編集）" />
    </div>
    <div className={`${Styles.stagePhone} ${Styles.stagePhoneBack}`}>
      <img className={Styles.shot} src={AppSalon} alt="学生アプリ（店舗紹介）" />
    </div>
    <div className={`${Styles.stagePhone} ${Styles.stagePhoneFront}`}>
      <img className={Styles.shot} src={AppTop} alt="学生アプリ（トップページ）" />
    </div>
  </div>
);

const Body = () => (
  <>
    <div className={Styles.mLeft}>
      <div className={Styles.kicker}>
        <span></span>
        <p>新卒採用をするならmemorii works</p>
      </div>
      <h1>美容業界の新卒採用を、<br />学校への求人提出から、<br />学生への掲載まで。</h1>
      <p className={Styles.lead}>
        求人票の作成から、学校への提出、学生アプリでの掲載、サロン見学・応募・選考管理まで。美容学生の採用に必要な流れを、ひとつにまとめます。
      </p>
      <div className={Styles.actions}>
        <a href="https://lin.ee/jHABap1" target="_blank" rel="noopener noreferrer">
          <button className={Styles.primary}>お問い合わせは LINEで受付中</button>
        </a>
        <a href="https://memorii-works.com/contact" className={Styles.secondary}>
          <IoDownloadOutline />資料をダウンロード
        </a>
      </div>
      <div className={Styles.speaker}>
        <img src={Speaker} alt="" />
        <p>LINEを送るだけで問い合わせ完了</p>
      </div>
    </div>
    <div className={Styles.mRight}>
      <Stage />
    </div>
  </>
);

const HomeMainVisual = () => {
  return (
    <>
    <div className={Styles.mainVisual}><Body /></div>
    <div className={Styles.mainVisualMobile}><Body /></div>
    </>
  );
}


export default HomeMainVisual;
